export default [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/error-page/:type',
    name: 'Error',
    component: 'Error' // 注意提供ErrorPage组件内的多语言翻译
  },
  // {
  //   path: '/redirect/*/*',
  //   name: 'redirect',
  //   menuCode: '001',
  //   component: 'redirect'
  // },
  {
    path: '/redirect',
    name: 'redirect',
    menuCode: '001',
    component: 'redirect'
  },
  {
    name: 'indexPage',
    path: '/index/:type?/:first?/:second?/:third?',
    menuCode: '001',
    component: 'index-page/index-page'
  },
  {
    name: 'home',
    path: '/home',
    menuCode: '001',
    component: 'home/home'
  },
  {
    name: 'personal',
    path: '/personal',
    menuCode: '001',
    component: 'personal-page/personal-page'
  },
  {
    name: 'data-view',
    path: '/data-view',
    menuCode: '001',
    component: 'home/data-view-home'
  },
  // {
  //   name: 'login1',
  //   path: '/login1',
  //   menuCode: '001',
  //   component: 'login/login'
  // },
  {
    path: '/mini-login',
    menuCode: '001',
    name: '/mini-login',
    component: 'login/mini-login'
  },
  {
    name: 'downloadPage',
    path: '/download/:type',
    menuCode: '001',
    component: 'download-page/download-page'
  },
  {
    name: 'system-configuration',
    path: '/system-configuration/:menuId?',
    menuCode: '001',
    component: 'system-configuration/system-configuration'
  },
  {
    name: 'menu-management',
    path: '/management/menu-management',
    menuCode: '001',
    component: 'management/menu-management/menu-management'
  },
  {
    path: '/management',
    name: 'management-page',
    menuCode: '001',
    component: 'management/management-page'
  },
  {
    path: '/management/widget-management',
    menuCode: '001',
    name: 'widget-management',
    component: 'management/widget-management/widget-management'
  },
  {
    path: '/management/home-model',
    menuCode: '001',
    name: 'home-model',
    component: 'management/home-configuration/home-model'
  },
  {
    path: '/management/nav-configuration',
    name: 'nav-configuration',
    menuCode: '001',
    component: 'management/nav-configuration/nav-configuration'
  },
  {
    path: '/management/login-configuration',
    menuCode: '001',
    name: 'login-configuration',
    component: 'management/login-configuration/login-configuration'
  },
  {
    path: '/management/data-view-configuration',
    menuCode: '001',
    name: 'data-view-configuration',
    component:
      'management/data-view-configuration/data-view-viewer/data-view-configuration'
  },
  {
    path: '/management/theme-configuration',
    menuCode: '001',
    name: 'theme-configuration',
    component: 'management/theme-configuration/theme-configuration'
  },
  {
    path: '/management/data-view-management',
    menuCode: '001',
    name: 'data-view-management',
    component: 'management/data-view-configuration/data-view-management'
  },
  {
    path: '/management/home-configuration',
    menuCode: '001',
    name: 'home-configuration',
    component: 'management/home-configuration/home-configuration'
  }
]
